import { HazardousMaterialEstimate } from "./hazardous-material-estimate";
import { LaborEstimate } from "./labor-estimate";
import { PartEstimate } from "./part-estimate";

export class CorrectionEstimate {
    constructor(correction: string,
                partEstimates: PartEstimate[] = [],
                laborEstimates: LaborEstimate[] = [],
                hazardousMaterialEstimates: HazardousMaterialEstimate[] = [],) {
        this.correction = correction;
        this.partEstimates = partEstimates;
        this.laborEstimates = laborEstimates;
        this.hazardousMaterialEstimates = hazardousMaterialEstimates;
    }
    
    public correction: string = "";
    public partEstimates: PartEstimate[] = [];
    public laborEstimates: LaborEstimate[] = [];
    public hazardousMaterialEstimates: HazardousMaterialEstimate[] = [];
}